import { LastMessageText } from '@halo/ui-chat-react';
import type { Msg } from '@halo/chat-sdk-react';
import { Box } from '@chakra-ui/react';
import { Emoji } from '@/components/Emoji';
import { MsgForwardIcon } from '../../msg-parts';
import { MsgImagePreviewContent } from './msg-image-preview-content';

export interface MsgImagePreviewProps {
  message: Msg;
}

export const MsgImagePreview = memo(function MsgImagePreview({ message }: MsgImagePreviewProps) {
  return (
    <LastMessageText>
      <Emoji.MessagePrefix reactions={message.emoji_reaction} />
      <MsgForwardIcon message={message} />
      <Box flex="1" minW="0" truncate>
        <MsgImagePreviewContent />
      </Box>
    </LastMessageText>
  );
});
